import React, { useState } from 'react';
import Tracking from 'lib/tracking';
import { useRouter } from 'next/router';
import css from './styles/faq-list.module.css';
interface FaqItemProps {
  question: string;
  children: JSX.Element;
}

const FaqItem: React.FC<FaqItemProps> = ({
  question,
  children,
}: FaqItemProps) => {
  const router = useRouter();
  const [collapsed, setCollapsed] = useState(true);
  const handleClickQuestion = () => {
    if (collapsed) {
      Tracking.trackEvent('Opened FAQ question', {
        question: question,
        pathname: router.pathname,
      });
    }
    setCollapsed(!collapsed);
  };
  return (
    <article className={css.faqListItem}>
      <h3 className={css.faqListQuestion}>
        <button aria-expanded={!collapsed} onClick={handleClickQuestion}>
          <div className={css.faqListIcon}>
            <svg
              fill="none"
              height="5"
              viewBox="0 0 9 5"
              width="9"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m8 1-3.5 3-3.5-3"
                stroke="currentColor"
                strokeLinecap="square"
              />
            </svg>
          </div>
          <div>{question}</div>
        </button>
      </h3>
      <div className={css.faqListAnswer} hidden={collapsed}>
        {children}
      </div>
    </article>
  );
};

function FaqList() {
  return (
    <div className={css.faq}>
      <div className={css.faqList}>
        <FaqItem question="What types of sources can I cite with this feature?">
          <p>
            For now, this web integration is only available for books. But we
            are already working on expanding our range of integrations to
            include automatic citations for web sources, journal articles,
            movies and much more!
          </p>
        </FaqItem>
        <FaqItem question="Is the integration free to use?">
          <>
            <p>
              Yes! You can add all of Bibcitation integrations to your web pages
              free of charge.
            </p>
          </>
        </FaqItem>
        <FaqItem question="How can I use this feature in my work?">
          <>
            <p>
              Whether you are a book publisher or a journalist, there are dozens
              of reasons why your users might want to create a citation on your
              website. If your line of work involves books, then our citation
              integration will become a useful addition to your website!
            </p>
          </>
        </FaqItem>
        <FaqItem question="How do I install the integration?">
          <>
            <p>
              1. First, fetch ISBN codes for all the sources you want to cite.
              In this example. we&apos;re using <i>Capital</i> by Thomas Piketty
              with the following ISBN number: <a>978067497985</a>.
            </p>

            <p>
              2. Then, copy the link below and replace &quot;xxxxxx&quot; with
              your book&apos;s ISBN number:{' '}
            </p>

            <p>
              <a>https://www.bibcitation.com/?type=book&query=xxxxxx </a>
            </p>

            <p>
              {' '}
              3. Okay, it&apos;s time to code a custom citation button for your
              website. Here, we&apos;re using the &#60;button&#62; tag, but
              you&apos;re free to choose any programming language you see fit.
            </p>
            <p>
              <a>
                &#60;button
                onclick=&quot;window.location.href=&apos;link&apos;&quot;&#62;
                text &#60;/button&#62;
              </a>
            </p>
            <p>
              4. All done. Now all you have to do is to add the link you
              generated during the second step to the button code on your
              website!
            </p>
            <p>
              <a>
                &#60;button onclick=&quot;window.location.href=
                &apos;https://www.bibcitation.com/?type=book&query=9780674979857&apos;&quot;&#62;
                text &#60;/button&#62;
              </a>
            </p>
          </>
        </FaqItem>
        <FaqItem question="Does Bibcitation have a citation generator integration?">
          <p>
            Coming soon! Our citation generator integration is scheduled for
            release in May 2023.{' '}
          </p>
        </FaqItem>
        <FaqItem question="What other products does Bibcitation offer?">
          <p>
            Bibcitation offers a whole ecosystem of cutting-edge citation tools.
            In addition to our{' '}
            <a href="bibcitation.com/"> citation generator website</a>, we offer
            a{' '}
            <a href="https://chrome.google.com/webstore/detail/bibcitation-%E2%80%94-free-instan/cnjkoanefhlhkagbpofjbafaonfejpgc">
              Bibcitation Add-on for Chrome
            </a>
            , a{' '}
            <a href="https://workspace.google.com/marketplace/app/bibcitation_bibliography_citation_genera/355051276479">
              Bibcitation Extension for Google Docs
            </a>
            , and a{' '}
            <a href="https://appsource.microsoft.com/en-us/product/office/WA200004996?exp=ubp8&tab=Overview">
              Bibcitation Add-in for Microsoft Word
            </a>
            .
          </p>
        </FaqItem>
      </div>
    </div>
  );
}

export default FaqList;
